import { render } from "./MdTableHeadSelection.vue?vue&type=template&id=7c872d7a"
import script from "./MdTableHeadSelection.vue?vue&type=script&lang=js"
export * from "./MdTableHeadSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__